import { EKwikUIInputSelectSize } from "./input-select.definitions";

export const DEFAULT_VALUES = {
  disabled: false,
  focus: false,
  formControlName: "form_control_input_select",
  hintContent: "",
  icon: "",
  id: "input_select",
  invalid: false,
  label: "Input Select",
  options: [],
  placeholder: "Please select an option",
  searchable: true,
  size: EKwikUIInputSelectSize.L
};

export const VALIDATE_KEY_VALUES = {
  disabled: true,
  focus: true,
  formControlName: true,
  hintContent: true,
  icon: true,
  id: true,
  invalid: true,
  label: true,
  options: true,
  placeholder: true,
  searchable: true,
  size: true
};
